<template>
  <nav :class="navClasses">
    <template v-if="this.breakpoints.hamburger.isBreakpoint">
      <div class="nav--hamburger" :class="{'expanded': this.hamburgerVisible}">
        <div id="announcement">
          <div class="announcement__content">
            <p class="lead">In the machine economy of 2030, UX will be key for success.</p>
            <p class="body">Wind River acquires Particle Design.</p>
            <button><a href="https://www.windriver.com/news/press/news-20210920">Read the press release</a></button>
          </div>
        </div>
        <div class="nav__bar">
          <router-link class="logo"
            v-on:click.native="handleMenuClick"
            v-bind:to="{ name: 'homepage' }"
          >
            <img src="../../assets/logo.svg" alt="">
          </router-link>
          <button class="nav__toggle" v-on:click="toggleHamburgerVisibility">
            <span class="copy">Toggle Nav</span>
          </button>
        </div>
        <div class="nav__content">
          <ul class="nav-links">
            <li v-for="link in nav" :key="link.text" class="nav-link">
              <router-link
                v-bind:to="{ name: link.name, params: link.params }"
                v-on:click.native="handleMenuClick"
              >
                {{link.text}}
              </router-link>
            </li>
          </ul>
        <div class="spacers">
          <span class="spacer"></span>
          <span class="spacer"></span>
          <span class="spacer"></span>
          <span class="spacer"></span>
          <span class="spacer"></span>
          <span class="spacer"></span>
          <span class="spacer"></span>
        </div>
          <p class="hire-us">
            Plan a project
            <br>
            <a href="/contact">Hire Us</a>
            </p>
          <ul class="footer-links">
          <li v-for="link in companyInfo.socialMedia" :key="link.platform" class="footer-link">
              <a :href="link.url">{{link.platform}}</a>
            </li>
          </ul>
        </div>
      </div>
    </template>
    <template v-else>
        <router-link v-bind:to="{ name: 'homepage' }" class="logo">
          <img src="../../assets/logo.svg" alt="">
        </router-link>
          <div id="announcement">
            <div class="announcement__content">
              <p class="lead">In the machine economy of 2030, UX will be key for success.</p>
              <p class="body">Wind River acquires Particle Design.</p>
            <button><a href="https://www.windriver.com/news/press/news-20210920">Read the press release</a></button>
            </div>
        </div>
      <div class="nav__content">
        <ul class="nav-links">
          <li v-for="link in nav" :key="link.text">
              <router-link v-bind:to="{ name: link.name, params: link.params }">
                {{link.text}}
                <div class="spacer"> </div>
              </router-link>
          </li>
        </ul>
      </div>
    </template>
  </nav>
</template>

<script>
import nav from '@/data/snippets/nav';
import companyInfo from '@/data/snippets/companyInfo';

import throttle from 'lodash/throttle';

export default {
  name: 'layoutNavigation',
  props: ['scrollPosition'],
  data() {
    return {
      nav: nav,
      companyInfo,
      hamburgerVisible: false,
      breakpoints: {
        hamburger: {
          size: [0, 1024],
          isBreakpoint: false,
        },
        desktop: {
          size: [1024, 10000],
          isBreakpoint: false,
        },
      },
    };
  },
  computed: {
    navClasses: function() {
      const classes = {};

      for (const key in this.breakpoints) {
        const breakpoint = this.breakpoints[key];
        if (breakpoint.isBreakpoint) {
          classes[`bp--${key}`] = true;
        }
      }

      classes['has-overlay'] = this.$store.state.scrollDirection === 'up' || this.scrollPosition <= 0;

      return classes;
    },
  },
  methods: {
    shouldNavHaveOverlay: function() {
      const scrollState = this.$store.state.scrollState;

      // if no nav scroll anchor, assume we should always show the bar
      if (!scrollState.beginNavOverlay) {
        return true;
      }

      if (scrollState.beginNavOverlay && scrollState.beginNavOverlay.isAboveViewport) {
        return true;
      }

      return false;
    },
    checkBreakpoints: function () {
      const width = window.innerWidth;
      const breakpoints = this.breakpoints;
      for (const key in breakpoints) {
        const breakpoint = breakpoints[key];

        if (width > breakpoint.size[0] && width <= breakpoint.size[1]) {
          breakpoints[key].isBreakpoint = true;
        } else {
          breakpoints[key].isBreakpoint = false;
        }
      }
      this.breakpoints = breakpoints;
    },

    toggleHamburgerVisibility() {
      this.hamburgerVisible = !this.hamburgerVisible;
    },

    handleMenuClick(/* event */) {
      this.closeNavMenu();
    },

    closeNavMenu() {
      this.hamburgerVisible = false;
    },
  },

  mounted: function() {
    this.checkBreakpoints();

    this.handleResize = throttle(this.checkBreakpoints, 50);
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy: function() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>

<style lang="scss">
@import '../../styles/_typography.scss';
@import '../../styles/_mixins.scss';

nav {
  &.bp--desktop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: $z-index--topmost;

    transform: translateY(-100%);
    transition: transform 250ms;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: $color--primary-white;
    }

    #announcement {
      background-color: #303030;
      color: $color--primary-white;
      height: 111px;
      background-image: url('../../assets/dotcircle.svg');
      background-repeat: no-repeat;
      display: flex;


      .announcement__content {
        width: 100%;
        
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }

      .lead {
        font-size: rem(20px);
        margin: rem(15px);
      }

      .body {
        font-size: rem(15px);
        margin: rem(15px);
      }

      button {
        background-color: $color--primary-highlight;
        color: $color--primary-white;
        margin: rem(15px);
        border-radius: 6px;
        border: none;
        width: rem(300px);
        font-size: rem(15px);
        height: rem(40px);

        & > a {
          color: $color--primary-white;
          text-decoration: none;
          margin: 0;
        }
      }
    }

    .nav__content {

      height: 111px;
      width: 100%;
      // max-width: $layout--max-width;
      margin: auto;

      display: flex;
      align-items: center;
      justify-content: flex-end;
    }

    .logo {
      display: flex;
      transform: translateY(100%);
      transition: transform 250ms;
      position: absolute;
      top: 0;
      left: 0;
    }

    &.has-overlay {
      transform: translateY(0);

      .logo {
        transform: translateY(100px);
      }
    }

    .nav-links {
      margin: 0;

      display: flex;
      padding: 0;
      align-items: center;

      list-style: none;

      a {
        padding: 0.5rem 1rem;
        margin: 0 1rem;
        display: block;

        @include type('nav-bar-link', $color--primary-dark);

        .spacer {
          opacity: 0;
          transform: translate(-50%, 100%);
          transition: all 150ms;
        }

        &:hover,
        &:focus,
        &:active {
          text-decoration: none;

          .spacer {
            opacity: 1;
            transform: translate(-50%, 0);
          }
        }

        &.router-link-active {
          .spacer {
            opacity: 1;
            transform: translate(-50%, 0);
          }
        }
      }

      .spacer {
        width: rem(5px);
        height: rem(5px);
        display: block;
        position: absolute;
        top: 100%;
        left: 50%;
        background: $color--primary-white;
      }
    }
  }

  &.bp--hamburger {
    z-index: $z-index--topmost;

  #announcement {
      background-color: #303030;
      color: $color--primary-white;
      height: 167px;
      background-image: url('../../assets/dotcircle.svg');
      background-repeat: no-repeat;
      background-position: right;
      display: flex;


      .announcement__content {
        width: 100%;
        
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-flow: row wrap;
      }

      .lead {
        font-size: rem(20px);
        margin: rem(10px) 0 0 rem(15px);
        width: 80%;
        line-height: 1.2;
      }

      .body {
        font-size: rem(15px);
        margin: 0 0 0 rem(15px);
        width: 80%;
      }

      button {
        background-color: $color--primary-highlight;
        color: $color--primary-white;
        padding: rem(10px);
        margin: rem(15px);
        border-radius: 6px;
        border: none;
        width: rem(300px);
        font-size: rem(18px);

        & > a {
          color: $color--primary-white;
        }
      }
    }

    }

  .nav--hamburger {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background: white;

    .nav__bar {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: rem(60px);
      z-index: 1;
    }

    .logo {
      width: rem(60px);
      display: flex;
      align-self: stretch;
      width: 148px;
      height: 148px;

      & > img {
        max-width: 100%;
      }
    }

    .nav__toggle {
      width: rem(60px);
      height: rem(60px);
      background: transparent;
      border: 0;
      cursor: pointer;

      &::before {
        content: '';
        position: absolute;
        top: 40%;
        left: 50%;
        width: 50%;
        height: 2px;
        transform: translate(-50%, 50%);
        background: black;
        transition: all 150ms;
      }

      &::after {
        content: '';
        position: absolute;
        bottom: 40%;
        left: 50%;
        width: 50%;
        height: 2px;
        transform: translate(-50%, 50%);
        background: black;
        transition: all 150ms;
      }

      .copy {
        position: absolute;
        left: -100vw;
        top: -100vh;
        width:1px;
        height:1px;
        overflow: hidden;
      }
    }

      .nav__content {
        position: absolute;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        overflow-y: scroll;
        background: #081E25;
        padding: rem(60px) rem(25px);

        opacity: 0;
        pointer-events: none;
        transition: opacity 250ms;

        color: #676F72;
        text-align: right;
      }

      .spacer {
        background: $color--primary-white;
      }

      .nav-links {
        list-style: none;
      }

      .nav-link {
        > a {
          @include type('nav-burger-page-link', $color--primary-highlight);

          &.router-link-active {
            text-decoration: underline;
          }
        }
      }

      .hire-us {
        > a {
          @include type('nav-burger-cta', $color--primary-white);
        }
      }

      .footer-links {
        list-style: none;
      }

      .footer-link {
        > a {
          @include type('nav-burger-social-media', $color--tertiary-midtone);
        }
      }

      &.expanded .nav__content {
        opacity: 1;
        pointer-events: auto;
      }

      &.expanded .logo {
        transform: translateY(-167px);
      }

      &.expanded .nav__toggle {
        transform: translateY(-168px);
        &::before {
          transform: rotate(45deg) translate(-50%,-50%);
          transform-origin: top left;
          top: 50%;
          left: 50%;
          background: white;
        }

        &::after {
          transform: rotate(-45deg) translate(-50%,-50%);
          transform-origin: top left;
          top: 50%;
          left: 50%;
          background: white;
        }
      }
    }
  }
</style>





// WEBPACK FOOTER //
// src/layouts/includes/navigation.vue